import { h } from 'preact'
import { Provider } from '@preact/prerender-data-provider'
import { Route, Router } from 'preact-router'

import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next, useTranslation } from 'react-i18next'

import { ConfigProvider, Space, Typography } from 'antd'
import fiFI from 'antd/lib/locale/fi_FI'
import { EuraIcon, EuraOverlay } from '@eura2021/ui-lib'

import { i18nInitOptions, i18nSetHTMLAttributes } from '@eura2021/uicomponent-lib'
import Hankeilmoitus from '../routes/hankeilmoitus'
import NotFoundPage from '../routes/notfound'
import Search from '../routes/search'

const I18Nbackend = {
  type: 'backend',
  init: (_services, _backendOptions, _i18nextOptions) => {
    /* use services and options */
  },
  read: (language, _namespace, callback) => {
    /* return resources */
    if (typeof document !== 'undefined') {
      if (document && document.querySelector) {
        const rawData = document.querySelector('script[type="__PREACT_CLI_DATA__"]')
        if (rawData && rawData.innerHTML) {
          const parsed = JSON.parse(decodeURIComponent(rawData.innerHTML))

          if (language === 'fi') {
            callback(null, parsed.preRenderData.fi)
          } else if (language === 'sv') {
            callback(null, parsed.preRenderData.sv)
          }
        }
      }
    } else {
      // Tätä käytetään käännöstiedostona SSR-buildissä
      callback(null, {
        hanke: {
          virkailijanHakuilmoitusSivu: {
            esikatselu: 'Esikatselu',
          },
        },
      })
    }

    /* if method fails/returns an error, call this: */
    /* callback(truthyValue, null) */
  },
}

i18n.on('languageChanged', (lng) => i18nSetHTMLAttributes(lng))
i18n.on('initialized', () => i18nSetHTMLAttributes(i18n.language))

i18n
  .use(I18Nbackend as any)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    ...i18nInitOptions,
    react: {
      useSuspense: false,
    },
  })

export const EuraPublicOverlay = (props: any): JSX.Element => {
  return (
    <EuraOverlay.Overlay
      footerContent={props.footerContent}
      icon={props.icon || <EuraIcon />}
      className={props.className}
      sider={props.sider}
      headerContent={
        <>
          {props.leftContent && (
            <EuraOverlay.LeftContent className={props.leftContentClassName}>{props.leftContent}</EuraOverlay.LeftContent>
          )}
          <>
            <EuraOverlay.MiddleContent>{props.middleContent ? props.middleContent : <></>}</EuraOverlay.MiddleContent>
          </>
          {props.rightContent && (
            <EuraOverlay.RightContent dataTestId='top.menu.container' className={props.rightContentClassName}>
              {props.rightContent}
            </EuraOverlay.RightContent>
          )}
          {props.bottomContent}
        </>
      }
    >
      {props.children}
    </EuraOverlay.Overlay>
  )
}

export default function App(props): JSX.Element {
  const { t, i18n, ready } = useTranslation()

  return (
    <div id='preact_root'>
      <Provider value={props}>
        <ConfigProvider locale={fiFI}>
          <EuraPublicOverlay
            icon={<EuraIcon />}
            leftContent={<EuraOverlay.Title title={'EURA 2021'} url={'/'} />}
            middleContent={<EuraOverlay.PageInfo pageInfoTop={ready ? t('yleiset.jarjestelma.nimi') : ''} />}
            bottomContent={
              <div style={{ width: '100%', position: 'absolute', borderBottom: 'solid 1px #d8d8d8', bottom: 0, height: '1px' }} />
            }
            rightContent={
              <Space direction='horizontal' align='center' size='middle' style={{ height: '100%' }}>
                <Typography.Link
                  href='#'
                  onClick={(e) => {
                    e.preventDefault()
                    i18n.changeLanguage('fi')
                  }}
                >
                  Suomi
                </Typography.Link>
                <Typography.Link
                  href='#'
                  onClick={(e) => {
                    e.preventDefault()
                    i18n.changeLanguage('sv')
                  }}
                >
                  Svenska
                </Typography.Link>
              </Space>
            }
          >
            {/* Match paddings with .ant-col__eura-content */}
            <div style={{ padding: '1.9rem 1.3rem 0rem 1.3rem' }}>
              <Router>
                <Route path='/hakuilmoitukset/' component={Search} />
                <Route path={'/hakuilmoitukset/hakuilmoitus/:id'} component={Hankeilmoitus} />
                <Route
                  path='/'
                  component={() => {
                    if (typeof window !== 'undefined') {
                      window.location.href = `${window.location.origin}/`
                    }
                    return null
                  }}
                />
                <Route default component={NotFoundPage} />
              </Router>
            </div>
          </EuraPublicOverlay>
        </ConfigProvider>
      </Provider>
    </div>
  )
}
